import { render } from "./NcrmWorkflowDetailsPage.vue?vue&type=template&id=4919a688&scoped=true"
import script from "./NcrmWorkflowDetailsPage.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowDetailsPage.vue?vue&type=script&lang=js"

import "./NcrmWorkflowDetailsPage.css?vue&type=style&index=0&id=4919a688&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4919a688"]])

export default __exports__